import { STATUS } from "@/lib/calc";

const StatusPill = ({ status, size = "sm", showDot = true, testid }) => {
  const s = STATUS[status] || STATUS.healthy;
  const sizeCls = size === "lg" ? "px-3 py-1 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold border ${s.bg} ${s.text} ${s.border} ${sizeCls}`}
      data-testid={testid || `status-pill-${status}`}
    >
      {showDot ? <span className={`w-1.5 h-1.5 rounded-full ${s.fill}`} /> : null}
      {s.label}
    </span>
  );
};

export default StatusPill;
